// extracted by mini-css-extract-plugin
export default {"wrap":"cI-z","fullWidth":"dI-z","hideOnDesktop":"eI-z","content":"fI-z","hasOpenedNav":"gI-z","crumbsList":"hI-z","dropdownsWrap":"iI-z"};